export default class CreatePositionRequest {
    name = '';
    description = '';
    minimumHours = 0;
    industryId = '';
    skillIds: string[] = [];
    qualificationIds: string[] = [];
    uniformIds: string[] = [];
}